var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Refresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b8p2e0kj8a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b8p2e0kj8a)",
    transform: "translate(-520.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.104 3.578C1.97 1.478 4.037 0 6.448 0c2.704 0 4.974 1.857 5.604 4.365",
    transform: "translate(520.000000, 211.000000) translate(1.500000, 1.500000) translate(0.000000, 0.650000)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9.124 3.551L12.055 4.365 12.868 1.438",
    transform: "translate(520.000000, 211.000000) translate(1.500000, 1.500000) translate(0.000000, 0.650000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.764 8.123c-.865 2.1-2.932 3.577-5.345 3.577-2.703 0-4.973-1.857-5.604-4.365",
    transform: "translate(520.000000, 211.000000) translate(1.500000, 1.500000) translate(0.000000, 0.650000)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M3.743 8.15L0.813 7.335 0 10.263",
    transform: "translate(520.000000, 211.000000) translate(1.500000, 1.500000) translate(0.000000, 0.650000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Refresh);
export default __webpack_public_path__ + "static/media/ico16Refresh.0a744226.svg";
export { ForwardRef as ReactComponent };